export const firstToUppercase = (name) =>
  name.charAt(0).toUpperCase() + name.slice(1);

export const isFieldSelected = (watchEvent) => {
  if (!watchEvent || watchEvent === "select") {
    return false;
  }
  return true;
};

export const getPopupNameByQueryLayer = (queryLayer) =>
  queryLayer === "zone" ? "{zone_name}" : "{la_name}";

//compare sort alphabetically
export const compare = (a, b) => {
  const a_name = a.name.trim();
  const b_name = b.name.trim();
  return a_name > b_name ? 1 : b_name > a_name ? -1 : 0;
};

export const findItemByValue = (object, value) =>
  object.find((x) => x.value === value);

export const getQueryLayerUniqueCode = (queryLayerField) => {
  return queryLayerField === "la" ? "la_unique_code=" : "zone_unique_code=";
};
